// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-hot-toast";
// import FileUpload from "../../components/common/FileUpload";
// import { DataGrid, GridColumnMenu, GridToolbar } from '@mui/x-data-grid';
// import Loader from "../../components/common/Loader";
// import Badge from '@mui/material/Badge';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faPlus, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
// import Dropdown from '../../components/common/InstituteDropDown';

// import { green, yellow, red, deepPurple } from '@mui/material/colors';
// import { SERVER_ORIGIN } from "../../utilities/constants";
// import HeaderCard from "../../components/common/HeaderCard";
// import InstututeMoU from "../../routes/institute/InstututeMoU";
// import css from "../../css/admin/users-page.module.css";
// import DownloadExcel from "../../components/common/DownloadExcel";
// import BackButton from "../../components/common/BackButton";
// import { hasReadOnlyAccess, getDashboardPath } from "../../utilities/helper_functions";
// import TermsAndConditionsButton from "../../components/common/TermsAndConditionsModal";

// const AllInstitute = () => {
//     const { _id } = useParams();
//     const [isLoading, setIsLoading] = useState(false);
//     const [limit, setLimit] = useState(0);
//     const [allInstitutes, setAllInstitutes] = useState([]);
//     const [page, setPage] = useState(1);
//     const [sortType, setSortType] = useState(true);
//     const [searchQuery, setSearchQuery] = useState("");
//     const [mouStatus, setMouStatus] = useState("");
//     const [totalPages, setTotalPages] = useState(0);
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedInstituteId, setSelectedInstituteId] = useState(null); // New state for selected institute ID
//     const [termsAvailability, setTermsAvailability] = useState({});
//     const [activeTab, setActiveTab] = useState('institute');

//     const handleButtonClick = () => {
//         setIsOpen(!isOpen);
//     };

//     const navigate = useNavigate();

//     useEffect(() => {
//         async function getAll() {
//             setIsLoading(true);

//             try {
//                 const em_id = _id;
//                 const response = await fetch(
//                     `${SERVER_ORIGIN}/api/em/auth/institute/all?page=${page}&limit=${limit}&search=${searchQuery}&sortBy=name&sortType=${sortType === true ? "asc" : "desc"}&isThalir=${activeTab === 'thalir' ? 'true' : 'false'}`,
//                     {
//                         method: "POST",
//                         headers: {
//                             "Content-Type": "application/json",
//                             "auth-token": sessionStorage.getItem("token"),
//                         },
//                         body: JSON.stringify({
//                             _id: em_id, isThalir: activeTab === 'thalir' ? true : false
//                         }),
//                     }
//                 );

//                 const result = await response.json();
//                 setIsLoading(false);
//                 if (response.status >= 400 && response.status < 600) {
//                     if (response.status === 401) {
//                         navigate("/admin/services");
//                     } else if (response.status === 500) {
//                         toast.error(result.statusText);
//                     }
//                 } else if (response.status === 200) {
//                     setAllInstitutes(result.filteredInstitutes);
//                     setTotalPages(result.totalPages);
//                     setMouStatus(result.filteredInstitutes.mouStatus);
//                 }
//             } catch (err) {
//                 setIsLoading(false);
//             }
//         }

//         getAll();
//     }, [page, sortType, searchQuery, navigate, limit, mouStatus, activeTab]);

//     const renderOnboardingStatus = (params) => {
//         let statusColor;
//         let statusText;
//         let textColor;

//         switch (params.value) {
//             case 'invited':
//                 statusColor = yellow[500];
//                 statusText = 'Invited';
//                 textColor = "black";
//                 break;
//             case 'pending':
//                 statusColor = deepPurple[500];
//                 statusText = 'Pending';
//                 textColor = "white";
//                 break;
//             case 'onboarded':
//                 statusColor = green[500];
//                 statusText = 'Onboarded';
//                 textColor = "white";
//                 break;
//             case 'approved':
//                 statusColor = green[500];
//                 statusText = 'Approved';
//                 textColor = "white";
//                 break;
//             case 'rejected':
//                 statusColor = red[500];
//                 statusText = 'Rejected';
//                 textColor = "white";
//                 break;
//             case 'submitted':
//                 statusColor = yellow[500];
//                 statusText = 'Submitted';
//                 textColor = "black";
//                 break;
//             default:
//                 statusColor = 'black';
//                 statusText = 'Unknown';
//                 textColor = "white";
//         }
//         return (
//             <Badge>
//                 <span style={{ backgroundColor: statusColor, padding: '6.4px 16px', borderRadius: '8px', color: textColor }}>
//                     {statusText}
//                 </span>
//             </Badge>
//         );
//     }

//     const getCurrentFinancialYear = () => {
//         const now = new Date();
//         const currentYear = now.getFullYear();
//         const currentMonth = now.getMonth() + 1; // 0-indexed month

//         if (currentMonth >= 4) {
//             // April onwards, financial year is current year to next year
//             return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
//         } else {
//             // January to March, financial year is previous year to current year
//             return `${currentYear - 1}-${currentYear.toString().slice(-2)}`;
//         }
//     };
//     // Function to check Terms availability for a specific institute
//     const checkTermsAvailability = async (institute) => {
//         if (!institute.createdBy) {
//             console.log(`Institute ${institute.name} has no createdBy field`);
//             return false;
//         }

//         try {
//             const currentFinancialYear = getCurrentFinancialYear();
//             const termsUrl = `${SERVER_ORIGIN}/api/terms/auth/active/${institute.createdBy}/${currentFinancialYear}`;

//             console.log(`Checking Terms for Institute: ${institute.name}`);
//             console.log(`Chapter EM ID: ${institute.createdBy}`);
//             console.log(`Financial Year: ${currentFinancialYear}`);
//             console.log(`Terms API URL: ${termsUrl}`);

//             const response = await fetch(termsUrl, {
//                 headers: {
//                     'auth-token': sessionStorage.getItem('token'),
//                 }
//             });

//             console.log(`Terms API Response Status for ${institute.name}: ${response.status}`);
//             console.log(`Response OK: ${response.ok}`);

//             // Let's check the actual response body
//             const responseText = await response.text();
//             console.log(`Response body for ${institute.name}:`, responseText);

//             let responseData;
//             try {
//                 responseData = JSON.parse(responseText);
//                 console.log(`Parsed response data for ${institute.name}:`, responseData);
//             } catch (parseError) {
//                 console.log(`Could not parse response as JSON for ${institute.name}:`, parseError);
//             }

//             // Check if Terms exist based on response status and content
//             let isAvailable = false;

//             if (response.status === 200) {
//                 // Success response - check if data actually exists (matching TermsAndConditionsModal logic)
//                 if (responseData && responseData.data) {
//                     const termsArray = responseData.data;
//                     if (Array.isArray(termsArray) && termsArray.length > 0) {
//                         isAvailable = true; // Array with data
//                     } else if (termsArray && !Array.isArray(termsArray)) {
//                         isAvailable = true; // Single object response
//                     } else {
//                         isAvailable = false; // Empty array or null data
//                     }
//                 } else {
//                     isAvailable = false; // No data property
//                 }
//             } else if (response.status === 404) {
//                 // Not found - definitely no Terms
//                 isAvailable = false;
//             } else {
//                 // Other error statuses
//                 isAvailable = false;
//             }

//             console.log(`Final Terms Available for ${institute.name}: ${isAvailable}`);

//             return isAvailable;
//         } catch (error) {
//             console.error('Error checking terms availability for', institute.name, ':', error);
//             return false;
//         }
//     };

//     // Function to check Terms availability for all institutes
//     const checkAllTermsAvailability = async (institutes) => {
//         console.log('Checking Terms availability for', institutes.length, 'institutes');
//         const availability = {};

//         // Use Promise.all to check all institutes in parallel
//         const promises = institutes.map(async (institute) => {
//             const isAvailable = await checkTermsAvailability(institute);
//             availability[institute._id] = isAvailable;
//             console.log(`Set availability for ${institute.name} (${institute._id}): ${isAvailable}`);
//         });

//         await Promise.all(promises);
//         console.log('Final Terms availability state:', availability);
//         setTermsAvailability(availability);
//     };

//     const renderEmailStatus = (params) => {
//         let statusColor;
//         let statusText;
//         let textColor;

//         switch (params.value) {
//             case 'sent':
//                 statusColor = green[500];
//                 statusText = 'Sent';
//                 textColor = "white";
//                 break;
//             case 'not sent':
//                 statusColor = red[500];
//                 statusText = 'Not Sent';
//                 textColor = "white";
//                 break;
//             default:
//                 statusColor = 'black';
//                 statusText = 'Unknown';
//                 textColor = "white";
//         }
//         return (
//             <Badge>
//                 <span style={{ borderRadius: '8px', backgroundColor: statusColor, padding: '6.4px 16px', color: textColor }}>
//                     {statusText}
//                 </span>
//             </Badge>
//         );
//     }

//     const rows = allInstitutes.map((institute, idx) => ({ ...institute, 'id': idx + 1 }));

//     const columns = [
//         {
//             field: 'id',
//             headerName: 'ID',
//             width: 90,
//             // renderCell: (params) => params.id++

//         },
//         {
//             field: 'name',
//             headerName: 'Institute Name',
//             width: 170,
//             // editable: true,
//         },
//         {
//             field: 'officerName',
//             headerName: 'Nodal Officer Name',
//             width: 150,
//             // editable: true,
//         },
//         {
//             field: 'officerNumber',
//             headerName: 'Nodal Officer Number (10 digits)',
//             width: 150,
//             // editable: true,
//         },
//         {
//             field: 'officerEmail',
//             headerName: 'Nodal Officer Email',
//             width: 200,
//             // editable: true,
//         },
//         {
//             field: 'city',
//             headerName: 'City',
//             width: 150,
//             // editable: true,
//         },

//         {
//             field: 'state',
//             headerName: 'State',
//             width: 150,
//             // editable: true,
//         },
//         {
//             field: 'designation',
//             headerName: 'Designation',
//             width: 150,
//             // editable: true,
//         },
//         {
//             field: 'studentCount',
//             headerName: 'Student Count',
//             width: 120,
//             align: 'center'
//         },
//         {
//             field: 'emailSentStatus',
//             headerName: 'Email Sent Status',
//             description: 'This column has a value getter and is not sortable.',
//             // sortable: false,
//             // align: 'center',
//             width: 160,
//             renderCell: renderEmailStatus
//             // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
//         },
//         {
//             field: 'onboardingSatus',
//             headerName: 'Onboarding Status',
//             description: 'This column has a value getter and is not sortable.',
//             width: 160,
//             // align: 'center',
//             renderCell: renderOnboardingStatus,
//         },
//         // {
//         //     field: 'mouStatus',
//         //     headerName: 'MOU Status',
//         //     description: 'This column has a value getter and is not sortable.',
//         //     width: 160,
//         //     // align: 'center',
//         //     renderCell: renderOnboardingStatus,
//         // },
//         // {
//         //     field: 'mouDuration',
//         //     headerName: 'Terms Available',
//         //     width: 150,
//         //     renderCell: (params) => {
//         //         const isAvailable = termsAvailability[params.row._id];
//         //         console.log(`Rendering Terms Status for ${params.row.name} (${params.row._id}): Available = ${isAvailable}`);

//         //         if (isAvailable === undefined) {
//         //             // Still loading
//         //             return (
//         //                 <span style={{
//         //                     backgroundColor: '#f5f5f5',
//         //                     color: '#666',
//         //                     padding: '4px 8px',
//         //                     borderRadius: '12px',
//         //                     fontSize: '12px',
//         //                     fontWeight: '500'
//         //                 }}>
//         //                     Checking...
//         //                 </span>
//         //             );
//         //         }

//         //         return (
//         //             <span style={{
//         //                 backgroundColor: isAvailable ? '#e8f5e8' : '#ffebee',
//         //                 color: isAvailable ? '#2e7d32' : '#c62828',
//         //                 padding: '4px 8px',
//         //                 borderRadius: '12px',
//         //                 fontSize: '12px',
//         //                 fontWeight: '500'
//         //             }}>
//         //                 {isAvailable ? 'Available' : 'Not Available'}
//         //             </span>
//         //         );
//         //     }
//         // },
//         {
//             field: 'mouStatus',
//             headerName: 'Terms Status',
//             width: 160,
//             renderCell: (params) => {
//                 const status = params.row.termsAccepted ? 'Accepted' : 'Pending';
//                 const bgColor = params.row.termsAccepted ? green[500] : yellow[500];
//                 const textColor = params.row.termsAccepted ? 'white' : 'black';

//                 return (
//                     <Badge>
//                         <span style={{
//                             backgroundColor: bgColor,
//                             padding: '6.4px 16px',
//                             borderRadius: '8px',
//                             color: textColor
//                         }}>
//                             {status}
//                         </span>
//                     </Badge>
//                 );
//             }
//         },
//         {
//             // field: 'mouStatus',
//             headerName: 'Terms & Conditions',
//             description: 'Shows if Terms and Conditions are available for this institute',
//             width: 180,
//             renderCell: (params) => {
//                 return (
//                     <TermsAndConditionsButton instituteId={params.row._id} text="View Terms" />

//                 );
//             }
//         },
//         // {
//         //     headerName: 'View MOU',
//         //     type: 'button',
//         //     width: 150,
//         //     renderCell: (params) => (
//         //         <InstututeMoU
//         //             show={isOpen}
//         //             intituteID={params.row._id}
//         //             onHide={handleButtonClick}
//         //             text={"Check MOU"}
//         //             onClick={handleButtonClick}
//         //         />
//         //     ),
//         // },
//     ];

//     const handleRowClick = (params) => {
//         setSelectedInstituteId(params.row._id);
//         // console.log(params.row_id);
//         setIsOpen(true);
//     };


//     function handleInstitutesClick() {
//         navigate("/institutes/insert");
//     }

//     function CustomColumnMenu(props) {
//         return (
//             <GridColumnMenu
//                 {...props}
//                 slots={{}}
//                 slotProps={{}}
//             />
//         );
//     }

//     return (
//         <div className={css.outerDiv}>
//             <div
//                 key="tab-navigation"
//                 style={{
//                     display: 'flex',
//                     borderBottom: '2px solid #e0e0e0',
//                     marginBottom: '1rem',
//                     visibility: 'visible',
//                     opacity: 1,
//                     backgroundColor: 'white',
//                     padding: '10px',
//                     borderRadius: '8px 8px 0 0',
//                     boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                 }}
//             >
//                 <button
//                     onClick={() => setActiveTab('institute')}
//                     style={{
//                         flex: 1,
//                         padding: '12px 24px',
//                         border: '2px solid #ccc',
//                         backgroundColor: activeTab === 'institute' ? '#0d5e9c' : '#f8f9fa',
//                         color: activeTab === 'institute' ? 'white' : '#333',
//                         cursor: 'pointer',
//                         borderRadius: '4px 4px 0 0',
//                         fontWeight: activeTab === 'institute' ? 'bold' : 'normal',
//                         transition: 'all 0.3s ease',
//                         fontSize: '16px'
//                     }}
//                 >
//                     {/* Institutes */}
//                     YUVA
//                 </button>
//                 <button
//                     onClick={() => setActiveTab('thalir')}
//                     style={{
//                         flex: 1,
//                         padding: '12px 24px',
//                         border: '2px solid #ccc',
//                         backgroundColor: activeTab === 'thalir' ? '#0d5e9c' : '#f8f9fa',
//                         color: activeTab === 'thalir' ? 'white' : '#333',
//                         cursor: 'pointer',
//                         borderRadius: '4px 4px 0 0',
//                         fontWeight: activeTab === 'thalir' ? 'bold' : 'normal',
//                         transition: 'all 0.3s ease',
//                         fontSize: '16px'
//                     }}
//                 >
//                     Thalir
//                 </button>
//             </div>
//             <HeaderCard>
//                 <BackButton text="Back to Dashboard" customPath={getDashboardPath()} />

//                 <h1 className="headerTitle">Institutes</h1>
//                 <hr />
//                 <p className="headerSubtitle">
//                     You can see the institute list here
//                 </p>
//                 <p className="headerSubtitle">
//                     Note: Once created, only the institute will be able to update the profile.
//                 </p>
//                 {/* <DownloadExcel />
//                 <div className='d-flex justify-content-evenly align-items-baseline'>
//                     <div>
//                         <FileUpload />
//                     </div>
//                     <div>
//                         <button
//                             className={`${css.fileUploadBtn} commonBtn`}
//                             onClick={handleInstitutesClick}
//                         >
//                             <FontAwesomeIcon icon={faPlus} style={{ color: "#ffffff", marginRight: "5px" }} /> Add Institute
//                         </button>
//                     </div>
//                 </div> */}
//             </HeaderCard>
//             <div className={css.filterBtns}>
//                 <div className='d-flex' style={{ position: 'relative', justifyContent: 'end', alignItems: 'center' }}>
//                     <input
//                         type="text"
//                         value={searchQuery}
//                         placeholder="Search from the list"
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         className={css.searchInput}
//                     />
//                     <FontAwesomeIcon icon={faMagnifyingGlass} style={{ color: "black", position: 'absolute', right: '10px' }} />
//                 </div>
//             </div>
//             {isLoading ? (
//                 <Loader />
//             ) : (
//                 <div>
//                     <DataGrid
//                         rows={rows}
//                         columns={columns}
//                         initialState={{
//                             pagination: {
//                                 paginationModel: { pageSize: 7, page: 0 },
//                             },
//                         }}
//                         onRowClick={handleRowClick} // Add this line to handle row clicks
//                         slots={{ columnMenu: CustomColumnMenu, toolbar: GridToolbar }}
//                     />
//                 </div>
//             )}
//         </div>
//     );
// };

// export default AllInstitute;

import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import FileUpload from "../../components/common/FileUpload";
import { DataGrid, GridColumnMenu, GridToolbar } from "@mui/x-data-grid";
import Loader from "../../components/common/Loader";
import Badge from "@mui/material/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faMagnifyingGlass,
  faSchool,
  faUserGraduate,
  faFileSignature,
  faIdBadge,
} from "@fortawesome/free-solid-svg-icons";
import Dropdown from "../../components/common/InstituteDropDown";
import { Row, Col } from "react-bootstrap";
import { green, yellow, red, deepPurple } from "@mui/material/colors";
import { SERVER_ORIGIN } from "../../utilities/constants";
import HeaderCard from "../../components/common/HeaderCard";
import SecCard from "../../components/common/SecCard";
import InstututeMoU from "../../routes/institute/InstututeMoU";
import css from "../../css/admin/users-page.module.css";
import DownloadExcel from "../../components/common/DownloadExcel";
import BackButton from "../../components/common/BackButton";
import {
  hasReadOnlyAccess,
  getDashboardPath,
} from "../../utilities/helper_functions";
import TermsAndConditionsButton from "../../components/common/TermsAndConditionsModal";

const AllInstitute = () => {
  const { _id } = useParams();

  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tab");
  const [isLoading, setIsLoading] = useState(false);
  const [limit, setLimit] = useState(0);
  const [allInstitutes, setAllInstitutes] = useState([]);
  const [page, setPage] = useState(1);
  const [sortType, setSortType] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [mouStatus, setMouStatus] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedInstituteId, setSelectedInstituteId] = useState(null);
  const [termsAvailability, setTermsAvailability] = useState({});
  //   const [activeTab, setActiveTab] = useState("institute");
  console.log("tabFromUrl>>", tabFromUrl);

  const [activeTab, setActiveTab] = useState(tabFromUrl || "institute");

  // New state for filters
  const [filters, setFilters] = useState({
    region: "",
    state: "",
    onboardingStatus: "",
    emailStatus: "",
    termsStatus: "",
  });

  const isReadOnly = hasReadOnlyAccess();

  // Get unique values for dropdowns
  const uniqueRegions = [
    ...new Set(allInstitutes.map((item) => item.region).filter(Boolean)),
  ];
  const uniqueStates = [
    ...new Set(allInstitutes.map((item) => item.state).filter(Boolean)),
  ];

  const handleButtonClick = () => {
    setIsOpen(!isOpen);
  };

  const navigate = useNavigate();

  // Debounce search input
  useEffect(() => {
    const handle = setTimeout(
      () => setDebouncedSearch(searchQuery.trim()),
      350
    );
    return () => clearTimeout(handle);
  }, [searchQuery]);

  useEffect(() => {
    async function getAll() {
      setIsLoading(true);

      try {
        const em_id = _id;
        const isThalir = activeTab === "thalir";

        console.log("Fetching data for tab:", activeTab);
        console.log("isThalir parameter:", isThalir);
        console.log("EM ID:", em_id);

        const response = await fetch(
          `${SERVER_ORIGIN}/api/em/auth/institute/all?page=${page}&limit=${limit}&search=${debouncedSearch}&sortBy=name&sortType=${sortType === true ? "asc" : "desc"
          }&isThalir=${isThalir}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": sessionStorage.getItem("token"),
            },
            body: JSON.stringify({
              _id: em_id,
              isThalir: isThalir,
            }),
          }
        );

        const result = await response.json();
        console.log("API Response:", result);
        console.log("Filtered Institutes:", result.filteredInstitutes);

        setIsLoading(false);
        if (response.status >= 400 && response.status < 600) {
          if (response.status === 401) {
            navigate("/admin/services");
          } else if (response.status === 500) {
            toast.error(result.statusText);
          }
        } else if (response.status === 200) {
          setAllInstitutes(result.filteredInstitutes || []);
          setTotalPages(result.totalPages || 0);
          setMouStatus(result.filteredInstitutes?.mouStatus || "");

          // Debug: Check if data is properly filtered
          if (
            result.filteredInstitutes &&
            result.filteredInstitutes.length > 0
          ) {
            console.log(
              `Loaded ${result.filteredInstitutes.length} records for ${activeTab} tab`
            );
            console.log(
              "Sample records:",
              result.filteredInstitutes.slice(0, 3)
            );

            // Check terms availability for loaded institutes
            checkAllTermsAvailability(result.filteredInstitutes);
          } else {
            console.log(`No records found for ${activeTab} tab`);
          }
        }
      } catch (err) {
        console.error("Error fetching institutes:", err);
        setIsLoading(false);
        toast.error("Failed to load data");
      }
    }

    getAll();
  }, [page, sortType, debouncedSearch, navigate, limit, activeTab, _id]);

  // Helper function to get current financial year
  const getCurrentFinancialYear = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;

    if (currentMonth >= 4) {
      return `${currentYear}-${(currentYear + 1).toString().slice(-2)}`;
    } else {
      return `${currentYear - 1}-${currentYear.toString().slice(-2)}`;
    }
  };

  // Function to check Terms availability for a specific institute
  const checkTermsAvailability = async (institute) => {
    if (!institute.createdBy) {
      console.log(`Institute ${institute.name} has no createdBy field`);
      return false;
    }

    try {
      const currentFinancialYear = getCurrentFinancialYear();
      // const termsUrl = `${SERVER_ORIGIN}/api/terms/auth/active/${institute.createdBy}/${currentFinancialYear}`;
      const termsUrl = `${SERVER_ORIGIN}/api/terms/auth/active/${currentFinancialYear}/${activeTab}`;

      const response = await fetch(termsUrl, {
        headers: {
          "auth-token": sessionStorage.getItem("token"),
        },
      });

      const responseText = await response.text();
      let responseData;
      try {
        responseData = JSON.parse(responseText);
      } catch (parseError) {
        console.log(
          `Could not parse response as JSON for ${institute.name}:`,
          parseError
        );
      }

      let isAvailable = false;

      if (response.status === 200) {
        if (responseData && responseData.data) {
          const termsArray = responseData.data;
          if (Array.isArray(termsArray) && termsArray.length > 0) {
            isAvailable = true;
          } else if (termsArray && !Array.isArray(termsArray)) {
            isAvailable = true;
          } else {
            isAvailable = false;
          }
        } else {
          isAvailable = false;
        }
      } else if (response.status === 404) {
        isAvailable = false;
      } else {
        isAvailable = false;
      }

      return isAvailable;
    } catch (error) {
      console.error(
        "Error checking terms availability for",
        institute.name,
        ":",
        error
      );
      return false;
    }
  };

  // Function to check Terms availability for all institutes
  const checkAllTermsAvailability = async (institutes) => {
    const availability = {};
    const promises = institutes.map(async (institute) => {
      const isAvailable = await checkTermsAvailability(institute);
      availability[institute._id] = isAvailable;
    });
    await Promise.all(promises);
    setTermsAvailability(availability);
  };

  // Function to calculate Terms availability statistics
  const getTermsStatistics = () => {
    const availabilityValues = Object.values(termsAvailability);
    const totalInstitutes = availabilityValues.length;
    const availableCount = availabilityValues.filter(
      (isAvailable) => isAvailable === true
    ).length;
    const notAvailableCount = availabilityValues.filter(
      (isAvailable) => isAvailable === false
    ).length;

    return {
      total: totalInstitutes,
      available: availableCount,
      notAvailable: notAvailableCount,
    };
  };

  // Function to calculate Email Status statistics
  const getEmailStatusStatistics = () => {
    const emailSent = allInstitutes.filter(
      (institute) => institute.emailSentStatus === "sent"
    ).length;
    const emailNotSent = allInstitutes.filter(
      (institute) =>
        institute.emailSentStatus === "not_sent" || !institute.emailSentStatus
    ).length;

    return {
      sent: emailSent,
      notSent: emailNotSent,
      total: allInstitutes.length,
    };
  };

  // Function to calculate Onboarding Status statistics
  const getOnboardingStatusStatistics = () => {
    const onboarded = allInstitutes.filter(
      (institute) => institute.onboardingSatus === "onboarded"
    ).length;
    const invited = allInstitutes.filter(
      (institute) => institute.onboardingSatus === "invited"
    ).length;
    const pending = allInstitutes.filter(
      (institute) => institute.onboardingSatus === "pending"
    ).length;

    return {
      onboarded: onboarded,
      invited: invited,
      pending: pending,
      total: allInstitutes.length,
    };
  };

  // Handle filter changes
  const handleFilterChange = (filterName, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterName]: value,
    }));
  };

  // Apply filters to data
  const filteredInstitutes = allInstitutes.filter((institute) => {
    return (
      (!filters.region || institute.region === filters.region) &&
      (!filters.state || institute.state === filters.state) &&
      (!filters.onboardingStatus ||
        institute.onboardingSatus === filters.onboardingStatus) &&
      (!filters.emailStatus ||
        institute.emailSentStatus === filters.emailStatus) &&
      (!filters.termsStatus ||
        (filters.termsStatus === "available"
          ? termsAvailability[institute._id]
          : filters.termsStatus === "not_available"
            ? !termsAvailability[institute._id]
            : true))
    );
  });

  // Clear all filters
  const clearAllFilters = () => {
    setFilters({
      region: "",
      state: "",
      onboardingStatus: "",
      emailStatus: "",
      termsStatus: "",
    });
    setSearchQuery("");
  };

  const renderOnboardingStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "invited":
        statusColor = yellow[500];
        statusText = "Invited";
        textColor = "black";
        break;
      case "pending":
        statusColor = deepPurple[500];
        statusText = "Pending";
        textColor = "white";
        break;
      case "onboarded":
        statusColor = green[500];
        statusText = "Onboarded";
        textColor = "white";
        break;
      case "approved":
        statusColor = green[500];
        statusText = "Approved";
        textColor = "white";
        break;
      case "rejected":
        statusColor = red[500];
        statusText = "Rejected";
        textColor = "white";
        break;
      case "submitted":
        statusColor = yellow[500];
        statusText = "Submitted";
        textColor = "black";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            borderRadius: "8px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  const renderEmailStatus = (params) => {
    let statusColor;
    let statusText;
    let textColor;

    switch (params.value) {
      case "sent":
        statusColor = green[500];
        statusText = "Sent";
        textColor = "white";
        break;
      case "not_sent":
        statusColor = red[500];
        statusText = "Not Sent";
        textColor = "white";
        break;
      default:
        statusColor = "black";
        statusText = "Unknown";
        textColor = "white";
    }
    return (
      <Badge>
        <span
          style={{
            borderRadius: "8px",
            backgroundColor: statusColor,
            padding: "6.4px 16px",
            color: textColor,
          }}
        >
          {statusText}
        </span>
      </Badge>
    );
  };

  const entityName = activeTab === "institute" ? "Institute" : "School";
  const statusStyles = {
    Accepted: {
      color: "#2563EB",
      background: "#DBEAFE",
    },
    Approved: {
      color: "#16A34A",
      background: "#DCFCE7",
    },
    "Not Accepted": {
      color: "#DC2626",
      background: "#FEE2E2",
    },
  };
  const baseColumns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
    },
    {
      field: "name",
      headerName: `${entityName} Name`,
      width: 220,
    },
    {
      field: "officerName",
      headerName: "Coordinator Name",
      width: 180,
    },
    {
      field: "officerNumber",
      headerName: "Coordinator Number",
      width: 180,
    },
    {
      field: "officerEmail",
      headerName: "Coordinator Email",
      width: 240,
    },

    {
      field: "city",
      headerName: "City",
      width: 120,
    },
    {
      field: "state",
      headerName: "State",
      width: 140,
    },
    {
      field: "region",
      headerName: "Region",
      width: 140,
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 150,
    },
    {
      field: "studentCount",
      headerName: "Student Count",
      width: 140,
      align: "center",
    },
  ];

  const instituteExtraColumns = [
    {
      field: "mouDuration",
      headerName: "Terms Duration",
      width: 140,
    },
    {
      field: "signDate",
      headerName: "Sign Date",
      width: 140,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      },
    },
  ];

  const commonTailColumns = [
    // {
    //   field: "emailSentStatus",
    //   headerName: "Email Sent Status",
    //   width: 160,
    //   renderCell: renderEmailStatus,
    // },
    {
      field: "onboardingSatus",
      headerName: "Onboarding Status",
      width: 160,
      renderCell: renderOnboardingStatus,
    },
    {
      field: "mouStatus",
      headerName: "Terms Status",
      width: 160,
      renderCell: (params) => {
        const status = params.row.termsAccepted ? "Accepted" : "Pending";
        const bgColor = params.row.termsAccepted ? green[500] : yellow[500];
        const textColor = params.row.termsAccepted ? "white" : "black";

        return (
          <Badge>


            <span
              style={{
                color: statusStyles[status].color,
                backgroundColor: statusStyles[status].background,
                padding: "4px 10px",
                borderRadius: "20px",
                fontWeight: 600,
                fontSize: "12px",
              }}
            >
              {status}
            </span>
            {/* <span
              style={{
                backgroundColor: bgColor,
                padding: "6.4px 16px",
                borderRadius: "8px",
                color: textColor,
              }}
            >
              {status}
            </span> */}
          </Badge>
        );
      },
    },
    {
      headerName: "Terms & Conditions",
      width: 180,
      renderCell: (params) => {
        return (
          <TermsAndConditionsButton
            instituteId={params.row._id}
            text="View Terms"
            tabFromUrl={activeTab}

          />
        );
      },
    },
    {
      field: "actions", // ✅ ADD FIELD

      headerName: "Action",
      type: "button",
      width: 230,
      renderCell: (params) => (
        <div className="d-flex justify-content-between">
          <div className="mx-3">
            <Dropdown _id={params.row._id} activeTab={activeTab} />
          </div>
        </div>
      ),
    },
  ];

  // Final columns based on activeTab
  const columns =
    activeTab === "institute"
      ? [...baseColumns, ...instituteExtraColumns, ...commonTailColumns]
      : [...baseColumns, ...commonTailColumns];

  const rows = filteredInstitutes.map((institute, idx) => ({
    ...institute,
    id: idx + 1,
  }));

  const handleRowClick = (params) => {
    setSelectedInstituteId(params.row._id);
    setIsOpen(true);
  };

  function handleInstitutesClick() {
    navigate(`/institutes/insert?tab=${activeTab}`);
  }

  function CustomColumnMenu(props) {
    return <GridColumnMenu {...props} slots={{}} slotProps={{}} />;
  }

  // Reusable stat card with icon and soft gradient
  const StatCard = ({ title, value, icon, gradient }) => (
    <div
      className={css.dashboardCard}
      style={{
        overflow: "hidden",
        borderRadius: 12,
        background: "#ffffff",
        boxShadow: "0 1px 3px rgba(16,24,40,.06)",
        transition: "box-shadow 200ms ease, transform 200ms ease",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px",
        }}
      >
        <h3
          className={css.cardTitle}
          style={{ margin: 0, fontSize: "14px", fontWeight: "600" }}
        >
          {title}
        </h3>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: gradient,
            color: "#fff",
          }}
        >
          <FontAwesomeIcon icon={icon} />
        </div>
      </div>
      <div className={css.cardContent} style={{ paddingTop: 0 }}>
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#111827" }}>
          {value}
        </div>
      </div>
    </div>
  );

  return (
    <div className={css.outerDiv}>
      {/* Tab Navigation */}
      {/* <div
        key="tab-navigation"
        style={{
          display: "flex",
          borderBottom: "2px solid #e0e0e0",
          marginBottom: "1rem",
          backgroundColor: "white",
          padding: "10px",
          borderRadius: "8px 8px 0 0",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <button
          onClick={() => setActiveTab("institute")}
          style={{
            flex: 1,
            padding: "12px 24px",
            border: "2px solid #ccc",
            backgroundColor: activeTab === "institute" ? "#0d5e9c" : "#f8f9fa",
            color: activeTab === "institute" ? "white" : "#333",
            cursor: "pointer",
            borderRadius: "4px 4px 0 0",
            fontWeight: activeTab === "institute" ? "bold" : "normal",
            transition: "all 0.3s ease",
            fontSize: "16px",
          }}
        >
          YUVA
        </button>
        <button
          onClick={() => setActiveTab("thalir")}
          style={{
            flex: 1,
            padding: "12px 24px",
            border: "2px solid #ccc",
            backgroundColor: activeTab === "thalir" ? "#0d5e9c" : "#f8f9fa",
            color: activeTab === "thalir" ? "white" : "#333",
            cursor: "pointer",
            borderRadius: "4px 4px 0 0",
            fontWeight: activeTab === "thalir" ? "bold" : "normal",
            transition: "all 0.3s ease",
            fontSize: "16px",
          }}
        >
          Thalir
        </button>
      </div> */}

      {/* <HeaderCard>
        <BackButton text="Back to Dashboard" customPath={getDashboardPath()} />

        <h1 className="headerTitle">
          {activeTab === "institute" ? "YUVA Institutes" : "Thalir Schools"}
        </h1>
        <hr />
        <p className="headerSubtitle">
          You can see the {activeTab === "institute" ? "institute" : "school"}{" "}
          list here
        </p>
        <p className="headerSubtitle">
          Note: Once created, only the{" "}
          {activeTab === "institute" ? "institute" : "school"} will be able to
          update the profile.
        </p>

        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "10px",
            borderRadius: "5px",
            marginTop: "10px",
            fontSize: "14px",
            border: "1px solid #e9ecef",
          }}
        >
          <strong>Debug Info:</strong> Showing {allInstitutes.length} records
          for {activeTab} tab
        </div>

        {!isReadOnly && (
          <div className="d-flex justify-content-evenly align-items-baseline mt-3">
            <div>
              <FileUpload />
            </div>
            <div>
              <button
                className={`${css.fileUploadBtn} commonBtn`}
                onClick={handleInstitutesClick}
              >
                <FontAwesomeIcon
                  icon={faPlus}
                  style={{ color: "#ffffff", marginRight: "5px" }}
                />
                Add {entityName}
              </button>
            </div>
            <div>
              <DownloadExcel />
            </div>
          </div>
        )}
      </HeaderCard> */}
      <div className={css.headerSection}>
        <div className={css.headerLeft}>
          <BackButton
            text="Back to Dashboard"
            customPath={getDashboardPath()}
          />
        </div>
      </div>

      {/* Statistics Cards */}
      <div className="my-4">
        <SecCard>
          <Row className="g-4">
            <div
              className={`${css.serviceHeader} d-flex justify-content-between align-items-center mb-3`}
            >
              <div className={css.serviceName}>
                {activeTab === "institute"
                  ? "Institute Data"
                  : "Thalir Data"}
              </div>


            </div>
            <Col md={6} lg={3} sm={12} xs={12}>
              <StatCard
                title={
                  activeTab === "institute"
                    ? "Total Institutes"
                    : "Total Schools"
                }
                value={allInstitutes.length}
                icon={faSchool}
                gradient="linear-gradient(135deg,#6366f1,#8b5cf6)"
              />
            </Col>

            <Col md={6} lg={3} sm={12} xs={12}>
              <StatCard
                title="Total Students"
                value={allInstitutes
                  .reduce(
                    (total, institute) => total + (institute.studentCount || 0),
                    0
                  )
                  .toLocaleString()}
                icon={faUserGraduate}
                gradient="linear-gradient(135deg,#10b981,#34d399)"
              />
            </Col>

            <Col md={6} lg={3} sm={12} xs={12}>
              <StatCard
                title="T&C Submitted"
                value={getTermsStatistics().available}
                icon={faFileSignature}
                gradient="linear-gradient(135deg,#f59e0b,#f97316)"
              />
            </Col>

            <Col md={6} lg={3} sm={12} xs={12}>
              <StatCard
                title="YUVA EC Count"
                value={
                  allInstitutes.filter((institute) => institute.yuvaEcCount > 0)
                    .length
                }
                icon={faIdBadge}
                gradient="linear-gradient(135deg,#06b6d4,#3b82f6)"
              />
            </Col>
          </Row>
        </SecCard>
      </div>

      {/* Search and Filters Section */}
      <div className={css.searchFiltersSection}>
        <div className={css.filtersContainer}>
          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Search</label>
            <div className={css.searchInputWrapper}>
              <input
                type="text"
                value={searchQuery}
                placeholder="Search from the list"
                onChange={(e) => setSearchQuery(e.target.value)}
                className={css.searchInput}
              />
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className={css.searchIcon}
              />
            </div>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Region</label>
            <select
              value={filters.region}
              onChange={(e) => handleFilterChange("region", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All Regions</option>
              {uniqueRegions.map((region) => (
                <option key={region} value={region}>
                  {region}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>State</label>
            <select
              value={filters.state}
              onChange={(e) => handleFilterChange("state", e.target.value)}
              className={css.filterSelect}
            >
              <option value="">All States</option>
              {uniqueStates.map((state) => (
                <option key={state} value={state}>
                  {state}
                </option>
              ))}
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Email Status</label>
            <select
              value={filters.emailStatus}
              onChange={(e) =>
                handleFilterChange("emailStatus", e.target.value)
              }
              className={css.filterSelect}
            >
              <option value="">All Status</option>
              <option value="sent">Sent</option>
              <option value="not_sent">Not Sent</option>
            </select>
          </div>

          <div className={css.filterGroup}>
            <label className={css.filterLabel}>Terms Status</label>
            <select
              value={filters.termsStatus}
              onChange={(e) =>
                handleFilterChange("termsStatus", e.target.value)
              }
              className={css.filterSelect}
            >
              <option value="">All Status</option>
              <option value="available">Available</option>
              <option value="not_available">Not Available</option>
            </select>
          </div>

          <button onClick={clearAllFilters} className={css.clearFiltersBtn}>
            Clear All
          </button>
        </div>
      </div>

      {isLoading ? (
        <Loader />
      ) : (
        <div className={css.dataGridContainer}>
          <DataGrid
            rows={rows}
            columns={columns}
            autoHeight
            density="compact"
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
            sx={{
              borderRadius: 2,
              border: "1px solid #e5e7eb",
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#f9fafb",
                color: "#111827",
                fontWeight: 600,
              },
              "& .MuiDataGrid-row:nth-of-type(odd)": {
                backgroundColor: "#fcfcfd",
              },
              "& .MuiDataGrid-row:hover": {
                backgroundColor: "#eef2ff",
              },
            }}
            slots={{ columnMenu: CustomColumnMenu, toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 300 },
              },
            }}
            loading={isLoading}
          />
        </div>
      )}
    </div>
  );
};

export default AllInstitute;